import { Action } from 'typescript-fsa';

import { createReducer, getArrayAfterAsyncCall } from '@topconagriculture/frontend-utils';

import {
  createMixer,
  deleteMixer,
  editMixer,
  getMixerDetailById,
  getMixersList,
  getMixerStatus,
} from './mixers.actions';
import { Mixer, MixerStatus } from './mixers.types';

export type MixersState = {
  readonly mixersList: Mixer[];
  readonly mixerStatus: MixerStatus;
};

export const initialState: MixersState = {
  mixersList: [],
  mixerStatus: {
    timeStamp: new Date(),
    state: '',
  },
};

const mixersReducer = createReducer(initialState, {
  [getMixersList.done.type]: (state: MixersState, action) => ({
    ...state,
    mixersList: getArrayAfterAsyncCall<Mixer>(state.mixersList, action),
  }),
  [getMixerDetailById.done.type]: (state: MixersState, action: Action<{ result: Mixer }>) => {
    const currentMixer = action.payload.result;
    return {
      ...state,
      mixersList: state.mixersList.map((mixer) => {
        if (mixer.id === currentMixer.id) {
          return {
            ...mixer,
            ...currentMixer,
            services: [currentMixer.service1, currentMixer.service2],
          };
        }
        return mixer;
      }),
    };
  },
  [createMixer.done.type]: (state: MixersState, action: Action<{ result: Mixer }>) => {
    const mixer = action.payload.result;
    return {
      ...state,
      mixersList: state.mixersList.concat(mixer),
    };
  },
  [editMixer.done.type]: (state: MixersState, action: Action<{ result: Mixer }>) => {
    const currentMixer = action.payload.result;
    return {
      ...state,
      mixersList: state.mixersList.map((mixer) => {
        if (mixer.id === currentMixer.id) {
          return {
            ...mixer,
            ...currentMixer,
          };
        }
        return mixer;
      }),
    };
  },
  [deleteMixer.done.type]: (state: MixersState, action: Action<{ result: string }>) => {
    const currentMixerId = action.payload.result;
    return {
      ...state,
      mixersList: state.mixersList.filter((mixer) => mixer.id !== currentMixerId),
    };
  },
  [getMixerStatus.done.type]: (state: MixersState, action: Action<{ result: MixerStatus; params: number }>) => ({
    ...state,
    mixerStatus: {
      ...action.payload.result,
      mixerId: action.payload.params,
    },
  }),
});

export default mixersReducer;
